const { algoliasearch, instantsearch } = window;
const { autocomplete } = window['@algolia/autocomplete-js'];
const { createLocalStorageRecentSearchesPlugin } =
  window['@algolia/autocomplete-plugin-recent-searches'];
const { createQuerySuggestionsPlugin } =
  window['@algolia/autocomplete-plugin-query-suggestions'];

import { connectConfigure, connectRange } from "instantsearch.js/es/connectors";

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

/*
  import { typesenseConfig } from './config.js';

    apiKey: typesenseConfig.apiKey,
*/

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    connectionTimeoutSeconds: 300,
    apiKey: "fR455meh9IqezHOyV2tLmhX26PbyPh3XE3UysrsUE6oPtPzr", // Be sure to use the search-only-api-key
    nodes: [
      { 
        host: "api.typesearch.org",
        // host: "10.78.1.38",
        port: 443,
        protocol: "https"
      }
    ]
  },
  // The following parameters are directly passed to Typesense's search API endpoint.
  //  So you can pass any parameters supported by the search endpoint below.
  //  query_by is required
  additionalSearchParameters: {
    query_by: "domain,font,vendor_url,manufacturer"
  }
});
const searchClient = typesenseInstantsearchAdapter.searchClient;

const search = instantsearch({
  indexName: 'latest_fonts',
  searchClient
});

const dateToUnixTimestamp = (dateStr, isStartOfDay) => {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  if (isStartOfDay) return Math.floor(date.getTime() / 1000);
  const endDate = new Date(Date.UTC(y, m - 1, d + 1));
  return Math.floor(endDate.getTime() / 1000) - 1;
};

const customDateRangeWidget = connectRange((renderOptions, isFirstRender) => {
  const { refine, currentRefinement } = renderOptions;
  const container = document.getElementById('date-range-filter');

  if (isFirstRender) {
    container.innerHTML = `
         <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
           <label for="date-from">From:</label>
           <input type="date" id="date-from" />
           <label for="date-to">To:</label>
           <input type="date" id="date-to" />
           <button id="clear-dates" style="cursor: pointer; padding: 6px 10px; background: #f8f9fa; border: 1px solid #ccc; border-radius: 4px;">Clear</button>
         </div>`;

    const startInput = document.getElementById('date-from');
    const endInput = document.getElementById('date-to');
    const clearBtn = document.getElementById('clear-dates');

    const applyRefinement = () => {
      const minVal = dateToUnixTimestamp(startInput.value, true);
      const maxVal = dateToUnixTimestamp(endInput.value, false);
      let refinement = {};
      if (minVal !== null) refinement.min = minVal;
      if (maxVal !== null) refinement.max = maxVal;
      refine(refinement);
    };

    startInput.addEventListener('change', applyRefinement);
    endInput.addEventListener('change', applyRefinement);
       
    clearBtn.addEventListener('click', () => {
      startInput.value = '';
      endInput.value = '';
      refine({});
    });
  }

  // Sync UI when InstantSearch state changes externally
  const currentMin = currentRefinement?.min ?? null;
  const currentMax = currentRefinement?.max ?? null;

  const startInput = document.getElementById('date-from');
  const endInput = document.getElementById('date-to');

  if (!startInput || !endInput) return; // safety
  startInput.value = currentMin ? new Date(currentMin * 1000).toISOString().slice(0, 10) : '';
  endInput.value = currentMax ? new Date((currentMax + 86400) * 1000).toISOString().slice(0, 10) : '';
});

const refinements = 
  instantsearch.widgets.refinementList({
    container: '#refinement-list',
    attribute: 'vendor_url',
    showMore: true,
    showMoreLimit: 25,
  });

const manufacturers = 
  instantsearch.widgets.refinementList({
    container: '#manufacturer-list',
    attribute: 'normalized_manufacturer',
    searchable: true,
    showMore: true,
    showMoreLimit: 25,
  });

const families = 
  instantsearch.widgets.refinementList({
    container: '#family-list',
    attribute: 'normalized_family',
    showMore: true,
    showMoreLimit: 200,
  });

const refinements_h =
  instantsearch.widgets.hierarchicalMenu({
    container: '#manufacturer-list',
    attributes: ['vendor_url', 'manufacturer'],
    showMore: true,
    sortBy: ['count:desc']
  });

// const datePicker = instantsearch.widgets.datePicker({
//   container: '#date-picker',
//   attribute: 'scanned_at'
// });

// const configure = 
//   instantsearch.widgets.configure({
//     length: 1000,
//   });

/*
const renderConfigure = (renderOptions, isFirstRender) => {
  const { refine, widgetParams } = renderOptions;
  if (isFirstRender) {
    const box = document.querySelector("#manufacturer-search-toggle");
    const familyBox = document.querySelector("#family-search-toggle");
    box.addEventListener("change", () => {
      const newConfiguration = typesenseInstantsearchAdapter.configuration;
      newConfiguration.additionalSearchParameters.query_by = box.checked ? "normalized_manufacturer" : "domain,font,vendor_url,manufacturer";
      typesenseInstantsearchAdapter.updateConfiguration(newConfiguration);
      search.refresh();
    });
    familyBox.addEventListener("change", () => {
      const newConfiguration = typesenseInstantsearchAdapter.configuration;
      newConfiguration.additionalSearchParameters.query_by = familyBox.checked ? "normalized_family" : "domain,font,vendor_url,manufacturer";
      typesenseInstantsearchAdapter.updateConfiguration(newConfiguration);
      search.refresh();
    });
  }
};

const configure = connectConfigure(renderConfigure)({searchParameters: {length: 1000}});
*/

const configure = instantsearch.widgets.configure({
  length: 1000,
  perPage: 50
});

// Dynamic field selector handler
function updateQueryByFields() {
  const checkedBoxes = document.querySelectorAll('.field-cb:checked');
  const selectedFields = Array.from(checkedBoxes).map(cb => cb.value).join(',');

  if (!selectedFields) {
    console.warn('⚠️ At least one field must be selected for search.');
    return;
  }

  // Clone config to avoid mutation warnings in InstantSearch
  const newConfig = { ...typesenseInstantsearchAdapter.configuration };
  newConfig.additionalSearchParameters.query_by = selectedFields;
  
  typesenseInstantsearchAdapter.updateConfiguration(newConfig);
  search.refresh(); // Triggers new search with updated fields
}

// Attach listeners once DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.field-cb').forEach(cb => {
    cb.addEventListener('change', updateQueryByFields);
  });
});

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, isSearchStalled } = renderOptions;
  console.log('log');
  const newConfiguration = typesenseInstantsearchAdapter.configuration;
  if (!query) {
    if (isFirstRender) {
      console.log('removing search');
      search.removeWidget(refinements);
      search.removeWidget(families);
      //search.addWidget(manufacturers);
    }
    //delete newConfiguration.additionalSearchParameters.sort_by;
  } else {
    //search.removeWidget(manufacturers);
    if (!search.renderState['latest_fonts'].refinementList) {
      console.log('adding search');
      //newConfiguration.additionalSearchParameters.sort_by = "scanned_at:desc";
      search.addWidget(refinements);
      search.addWidget(families);
    }
  }
  console.log(newConfiguration);
  typesenseInstantsearchAdapter.updateConfiguration(newConfiguration);
}

function createDropdown(id) {
  const dropdown = document.createElement('div');
  dropdown.className = 'scanned-font-dropdown';
  dropdown.id = `dropdown-${id}`;
  dropdown.style.cssText = `
      display: none;
      position: absolute;
      background: white;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
      margin-top: 5px;
      z-index: 1000;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      max-width: 400px;
      min-width: 300px;
    `;

  const content = document.createElement('div');
  dropdown.appendChild(content);
  return dropdown;
}

// Function to handle click on scanned font ID
function handleScannedFontClick(event, scannedFontId) {
  event.preventDefault();

  const container = event.target.closest('.hit-description');
  if (!container) return;

  // Toggle dropdown visibility
  const existingDropdown = document.getElementById(`dropdown-${scannedFontId}`);
  if (existingDropdown) {
    existingDropdown.style.display = existingDropdown.style.display === 'none' ? 'block' : 'none';
    return;
  }

  // Create new dropdown
  const dropdown = createDropdown(scannedFontId, null);
  container.appendChild(dropdown);

  // Fetch data from server
  fetch(`/scanned-fonts/${scannedFontId}`)
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        dropdown.innerHTML = '<p>Error loading data</p>';
        return;
      }

      // Update dropdown with actual data
      const content = dropdown.querySelector('div');
      const metadataContent = data.metadata ? `
        <div style="margin-top: 10px; border-top: 1px solid #eee; padding-top: 10px;">
        <h5>Metadata:</h5>
        <p><strong>Identifier:</strong> ${data.metadata.identifier || 'N/A'}</p>
        <p><strong>Trademark:</strong> ${data.metadata.trademark || 'N/A'}</p>
        <p><strong>Manufacturer:</strong> ${data.metadata.manufacturer || 'N/A'}</p>
        <p><strong>Designer:</strong> ${data.metadata.designer || 'N/A'}</p>
        <p><strong>Vendor URL:</strong> ${data.metadata.vendor_url || 'N/A'}</p>
        <p><strong>Description:</strong> ${data.metadata.description || 'N/A'}</p>
        <p><strong>License:</strong> ${data.metadata.license || 'N/A'}</p>
        <p><strong>Designer URL:</strong> ${data.metadata.designer_url || 'N/A'}</p>
        </div>
      ` : '';

      const scanDetailsContent = `
          <div style="margin-top: 10px; border-top: 1px solid #eee; padding-top: 10px;">
            <h5>Scan Details:</h5>
            <p><strong>Scan ID:</strong> ${data.scan?.id || 'N/A'}</p>
            <p><strong>Domain:</strong> ${data.scan?.domain || 'N/A'}</p>
            <p><strong>Inserted At:</strong> ${data.scan?.inserted_at || 'N/A'}</p>
          </div>
        `;

      content.innerHTML = `
          <h4>Scanned Font Details</h4>
          <p><strong>ID:</strong> ${data.id}</p>
          <p><strong>Real URL:</strong> ${data.real_url || 'N/A'}</p>
          ${metadataContent}
          ${scanDetailsContent}
        `;
    })
    .catch(error => {
      console.error('Error fetching scanned font data:', error);
      dropdown.innerHTML = '<p>Error loading data</p>';
    });

  // Show dropdown
  dropdown.style.display = 'block';
};

const removeDisjunctiveFacetWidget = {
  $$type: 'RemoveDisjunctiveFacet',
  init({state}) {console.log(state);state.removeDisjunctiveFacet('scanned_at');},
  render(renderOptions) {
    const { onSearchParameters } = renderOptions.removeDisjunctiveFacet('scanned_at');
    console.log("hello");
    console.log(onSearchParameters);
    onSearchParameters((searchParameters) => {
      searchParameters.removeDisjunctiveFacet('scanned_at');
      return searchParameters;
    });
  },
  dispose() {}
};


const virtualSearchBox = instantsearch.connectors.connectSearchBox(renderSearchBox);

search.addWidgets([
  virtualSearchBox({}),
  //customDateRangeWidget({ min:0, max: 4000000000, attribute: 'scanned_at' }), // disabled due to dumb facet requirement
  //removeDisjunctiveFacetWidget,
  instantsearch.widgets.stats({
    container: '#stats'
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      item(hit, {html, components}) {
      const scanned_at = new Date(hit.scanned_at * 1000)
      return html`
        <div>
          <img src="" align="left" alt="" />
          <div class="hit-name">
            <a href="http://${hit.domain}">${components.Highlight({ hit, "attribute": "domain" })}</a>
          </div>
          <div class="hit-description">
            Font : ${components.Highlight({ hit, "attribute": "font" })}
          </div>
          <div class="hit-description">
            Vendor URL : ${components.Highlight({ hit, "attribute": "vendor_url" })}
          </div>
          <div class="hit-description">
            Font URL: ${hit.font_url}
          </div>
          <div class="hit-description">
	    Manufacturer : ${components.Highlight({ hit, "attribute": "manufacturer" })} (${components.Highlight({ hit, "attribute": "normalized_manufacturer" })})
          </div>
          <div class="hit-description">
            Family: ${components.Highlight({ hit, "attribute": "family" })} (${components.Highlight({ hit, "attribute": "normalized_family" })})
          </div>
          <div class="hit-description">
            Scanned at: ${scanned_at.toLocaleString()}
          </div>
          <div class="hit-description">
            scanned font id: 
            <span class="scanned-font-id" data-font-id="${hit.scanned_font_id}">${hit.scanned_font_id}</span>
          </div>
        </div>
      `;
      },},
  }),
  configure,
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
]);

search.start();

// Add global function to window for onclick handlers
window.handleScannedFontClick = handleScannedFontClick;

// Attach event listeners after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const hitsContainer = document.querySelector('#hits');
  if (hitsContainer) {
    hitsContainer.addEventListener('click', function(event) {
      const target = event.target;
      if (target.classList.contains('scanned-font-id')) {
        const fontId = target.getAttribute('data-font-id');
        handleScannedFontClick(event, fontId);
      }
    });
  }
});

const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
  key: 'instantsearch',
  limit: 3,
  transformSource({ source }) {
    return {
      ...source,
      onSelect({ setIsOpen, setQuery, item, event }) {
        onSelect({ setQuery, setIsOpen, event, query: item.label });
      },
    };
  },
});

const querySuggestionsPlugin = createQuerySuggestionsPlugin({
  searchClient,
  indexName: 'latest_fonts',
  getSearchParams() {
    return recentSearchesPlugin.data.getAlgoliaSearchParams({ hitsPerPage: 6 });
  },
  transformSource({ source }) {
    return {
      ...source,
      sourceId: 'querySuggestionsPlugin',
      onSelect({ setIsOpen, setQuery, event, item }) {
        onSelect({ setQuery, setIsOpen, event, query: item.query });
      },
      getItems(params) {
        if (!params.state.query) {
          return [];
        }

        return source.getItems(params);
      },
    };
  },
});

autocomplete({
  container: '#searchbox',
  openOnFocus: true,
  detachedMediaQuery: 'none',
  onSubmit({ state }) {
    setInstantSearchUiState({ query: state.query });
  },
  plugins: [recentSearchesPlugin, querySuggestionsPlugin],
});

function setInstantSearchUiState(indexUiState) {
  search.mainIndex.setIndexUiState({ page: 1, ...indexUiState });
}

function onSelect({ setIsOpen, setQuery, event, query }) {
  if (isModifierEvent(event)) {
    return;
  }

  setQuery(query);
  setIsOpen(false);
  setInstantSearchUiState({ query });
}

function isModifierEvent(event) {
  const isMiddleClick = event.button === 1;

  return (
    isMiddleClick ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey
  );
}
